// extracted by mini-css-extract-plugin
export var cardHeader = "_fv-0";
export var reorderHandle = "_fv-3";
export var titleArea = "_fv-1";
export var titleAreaWithHandle = "_fv-2";